import * as React from 'react'

import { inject, observer } from 'mobx-react'

import ChatScreens from '~/client/src/shared/chat2/components/ChatScreens'
import WorkflowCardDataStore from '~/client/src/shared/chat2/components/workflow/WorkflowCardData.store'
import { ChatShellStore } from '~/client/src/shared/chat2/web/ChatShell.store'
import ChatService from '~/client/src/shared/services/ChatService/Chat.service'
import StruxHubAuthService from '~/client/src/shared/services/StruxHubAuthService'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import GraphExecutorStore from '~/client/src/shared/stores/domain/GraphExecutor.store'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'
import ProjectRolesStore from '~/client/src/shared/stores/domain/ProjectRoles.store'
import ProjectsStore from '~/client/src/shared/stores/domain/Projects.store'
import ProjectTeamsStore from '~/client/src/shared/stores/domain/ProjectTeams.store'
import ProjectTradesStore from '~/client/src/shared/stores/domain/ProjectTrades.store'
import TagsStore from '~/client/src/shared/stores/domain/Tags.store'
import UserProjectsStore from '~/client/src/shared/stores/domain/UserProjects.store'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'
import InitialState from '~/client/src/shared/stores/InitialState'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

interface IProps {
  onClose: () => void

  state?: InitialState
  struxHubAuthService?: StruxHubAuthService
  chatService?: ChatService
  projectMembersStore?: ProjectMembersStore
  userProjectsStore?: UserProjectsStore
  companiesStore?: CompaniesStore
  projectRolesStore?: ProjectRolesStore
  projectTeamsStore?: ProjectTeamsStore
  projectTradesStore?: ProjectTradesStore
  tagsStore?: TagsStore
  projectDateStore?: ProjectDateStore
  projectsStore?: ProjectsStore
  graphExecutorStore?: GraphExecutorStore
  permitTypesStore?: WorkflowTypesStore
  locationAttributesStore?: LocationAttributesStore
}

// The desktop chat surface: the same shell and screens as mobile web, framed
// by the right-sidebar chrome (a close affordance on the inbox, Enter sends).
@inject(
  'state',
  'struxHubAuthService',
  'chatService',
  'projectMembersStore',
  'userProjectsStore',
  'companiesStore',
  'projectRolesStore',
  'projectTeamsStore',
  'projectTradesStore',
  'tagsStore',
  'projectDateStore',
  'projectsStore',
  'graphExecutorStore',
  'permitTypesStore',
  'locationAttributesStore',
)
@observer
export default class ChatV2Panel extends React.Component<IProps> {
  private readonly shell: ChatShellStore
  // Called from inside child observer renders, where reading this.props is
  // forbidden; the injected stores are stable, so they are captured here.
  private readonly createWorkflowCardStore: () => WorkflowCardDataStore

  public constructor(props: IProps) {
    super(props)
    this.shell = new ChatShellStore({
      state: props.state,
      struxHubAuthService: props.struxHubAuthService,
      chatService: props.chatService,
      projectMembersStore: props.projectMembersStore,
      userProjectsStore: props.userProjectsStore,
      companiesStore: props.companiesStore,
      projectRolesStore: props.projectRolesStore,
    })
    this.createWorkflowCardStore = () =>
      new WorkflowCardDataStore(
        props.state,
        props.projectsStore,
        props.graphExecutorStore,
        props.projectDateStore,
        props.permitTypesStore,
        props.companiesStore,
        props.locationAttributesStore,
      )
  }

  public componentDidMount() {
    this.shell.mount()
  }

  public componentWillUnmount() {
    this.shell.unmount()
  }

  public render() {
    return (
      <div className="tw:flex tw:h-full tw:flex-col">
        <div className="tw:min-h-0 tw:flex-1">
          <ChatScreens
            shell={this.shell}
            projectDateStore={this.props.projectDateStore}
            selectorStores={{
              state: this.props.state,
              projectMembersStore: this.props.projectMembersStore,
              userProjectsStore: this.props.userProjectsStore,
              companiesStore: this.props.companiesStore,
              projectRolesStore: this.props.projectRolesStore,
              projectTeamsStore: this.props.projectTeamsStore,
              projectTradesStore: this.props.projectTradesStore,
              tagsStore: this.props.tagsStore,
            }}
            createWorkflowCardStore={this.createWorkflowCardStore}
            shouldSendOnEnter={true}
            onClose={this.props.onClose}
          />
        </div>
      </div>
    )
  }
}
